import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import { useSelector } from 'react-redux';
import { IAllStates } from '../../../../../../../../store/rootReducer';
import { ContractService } from '../../../../service';
import { ErrorToast } from '../../../../../../../../utils/toasters';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { getFilteredChartsData } from '../../../../../../../../shared/functions/Functions';
import { IAudienceCharts } from '../../../../../book/offer/dto/IAudienceCharts';
import { IAudienceDataModal } from '../../../../../book/offer/dto/IAudienceDataModal';
import AudienceData from '../../../../../book/offer/modal/tabs/audience/AudienceData';
import AudienceKpiScreenshots from '../../../../../book/offer/modal/tabs/audience/AudienceKpiScreenshots';
import { AudienceCharts } from '../../../../../book/offer/modal/tabs/audience/AudienceCharts';
import CardLayout from '../../../../../../../../shared/components/card/CardLayout';

const ContractAudienceData = () => {
    const { activeTabModal, userId, user } = useSelector((state: IAllStates) => state.contractBrand);
    const [audienceData, setAudienceData] = useState<IAudienceDataModal>();
    const [allCharts, setAllCharts] = useState<IAudienceCharts>({
        engagementChart: [],
        followersChart: [],
        followingChart: [],
        likesChart: [],
    });

    const [value, setValue] = React.useState('0');

    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setValue(newValue);
    };

    useEffect(() => {
        if (activeTabModal === '2') {
            ContractService.getAudienceDataModal(userId)
                .then(response => {
                    setAudienceData(response);
                    setAllCharts(getFilteredChartsData(response.chartData));
                })
                .catch(err => ErrorToast(err));
        }
    }, [userId]);

    return (
        <Box>
            <CardLayout classCard="mb-4">
                <TabContext value={value}>
                    <TabList onChange={handleChange}>
                        {audienceData?.platformDataArray.map((platformData, index) => {
                            return (
                                <Tab key={index} label={`${platformData?.mainPlatform?.name}`} value={String(index)} />
                            );
                        })}
                    </TabList>
                    {audienceData?.platformDataArray.map((platformData, index) => {
                        return (
                            <TabPanel key={index} value={String(index)}>
                                <AudienceData audienceData={platformData} />
                            </TabPanel>
                        );
                    })}
                </TabContext>
            </CardLayout>
            <hr className="border-secondary" />
            {!!user?.userKpiScreenshots?.length && <AudienceKpiScreenshots user={user} />}
            <AudienceCharts charts={allCharts} chartDates={audienceData?.chartDates ?? []} />
        </Box>
    );
};

export default ContractAudienceData;
